export const trySetTokenFromQueryString = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("qs-token");
  const farm = searchParams.get("farm");

  if (token) {
    localStorage.setItem("auth", token);
  }

  if (farm) {
    localStorage.setItem("farm", farm);
  }
};
